import React from 'react';

export default function RouterNodeDetailsSidepanelContent(): JSX.Element {
  // TODO(BNCH-126759): Add support for rendering router node configuration to sidepanel
  return <div>Placeholder router node sidepanel content</div>;
}
